import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import "./assets/styles/main.css";

import ucHead from '@/components/ucHead'
import ucHeadWhite from '@/components/ucHeadWhite'
import ucHeadNews from '@/components/ucHeadNews'
import ucFoot from '@/components/ucFoot'
//引入动画
import 'animate.css';

createApp(App).use(router)
.component('ucHead', ucHead)
.component('ucHeadWhite', ucHeadWhite)
.component('ucHeadNews', ucHeadNews)
.component('ucFoot', ucFoot).mount('#app')
